import React from 'react';
import { getIn } from '@client/shared/utils/immutableUtils/immutableUtils';
import styleHelper from '@client/shared/styles/styleHelper.scss';
import ReactLink from '@client/components/reactLink/ReactLink';
import { valueOrEmptyStr } from '@client/shared/utils/utils/utils';
import Image from '@client/components/image/Image';
import Markdown from '@client/components/markdown/Markdown';
import styles from './eventCard.scss';

const EventCard = ({ data, className }) => {
  const urlToEvent = getIn(data, 'fields', 'slug');
  const eventImageUrl = getIn(data, 'fields', 'eventImageUrl');
  return (
    <ReactLink className={styles.eventCard} to={`/event/${urlToEvent}`}>
      <div className={className ? className : ''}>
        {eventImageUrl && (
          <div className={`${styles.imageContainer}`}>
            <Image className={styles.eventImage} src={eventImageUrl} />
          </div>
        )}
        <div
          className={`${styleHelper.flexCol} ${styleHelper.layoutMobileSidePadding}`}
        >
          <div className={`${styleHelper.titleSmPrimary} ${styles.subTitle}`}>
            {valueOrEmptyStr(getIn(data, 'fields', 'eventSubTitle'))}
          </div>
          <div className={styles.description}>
            <Markdown
              className={styles.markdown}
              value={valueOrEmptyStr(
                getIn(data, 'fields', 'eventShortDescriptionSummary')
              )}
            />
          </div>
        </div>
      </div>
    </ReactLink>
  );
};

export default EventCard;
